import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { ToggleFilter } from 'searchCards/ToggleFilter';

const FILTER = TOGGLE_FILTERS.bidToEarnFilter;

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => <ToggleFilter filter={FILTER} on={['true']} autoHide />,
  accordionOptions: { startsOpen },
});
